"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const addBlockFilter_1 = __importDefault(require("../helps/addBlockFilter"));
const watsFilter_1 = __importDefault(require("../helps/watsFilter"));
//= const addFilterLamps
const addFilterLamps = (currentArrLamps, typeLamps) => {
    try {
        switch (typeLamps) {
            case 'panels':
                // добавление новой сортировки по выбранному полю
                addNewSortForLamps(currentArrLamps, 'colorLightK', 'Цвет свечения', 'K');
                addNewSortForLamps(currentArrLamps, 'wats', 'Мощность', 'W');
                break;
            case 'trek':
                // добавление новой сортировки по выбранному полю
                addNewSortForLamps(currentArrLamps, 'color', 'Цвет', '');
                addNewSortForLamps(currentArrLamps, 'patron', 'Патрон', '');
                break;
            case 'lustre':
                // добавление новой сортировки по выбранному полю
                addNewSortForLamps(currentArrLamps, 'material', 'Материал', '');
                addNewSortForLamps(currentArrLamps, 'patron', 'Патрон', '');
                addNewSortForLamps(currentArrLamps, 'color', 'Цвет', '');
                break;
            case 'dot':
                // добавление новой сортировки по выбранному полю
                addNewSortForLamps(currentArrLamps, 'patron', 'Цоколь', '');
                addNewSortForLamps(currentArrLamps, 'color', 'Цвет', '');
                addNewSortForLamps(currentArrLamps, 'colorLightK', 'Подсветка Led', '');
                break;
            case 'light':
                // добавление новой сортировки по выбранному полю
                addNewSortForLamps(currentArrLamps, 'colorLightK', 'Цвет свечения', '');
                addNewSortForLamps(currentArrLamps, 'patron', 'Пульт', '');
                (0, watsFilter_1.default)('Мощность');
                addNewSortForLamps(currentArrLamps, 'material', 'Серия', '');
                break;
            case 'spot':
                // добавление новой сортировки по выбранному полю
                addNewSortForLamps(currentArrLamps, 'material', 'Материал', '');
                addNewSortForLamps(currentArrLamps, 'rotation', 'Вращение', '');
                addNewSortForLamps(currentArrLamps, 'patron', 'Патрон', '');
                addNewSortForLamps(currentArrLamps, 'color', 'Цвет', '');
                break;
            default:
                break;
        }
    }
    catch (error) {
        console.log('Error in functions addFilterLamps >>> ', error);
    }
};
// добавление новой сортировки по выбранному полю
// arrayObjectLamps - массив с обьектами светильников для сортировки
// keySort - ключ по которому будет сортировка
// title - заголовок для блока с фильтрами
// unit - единицы измирения, например 80 W
function addNewSortForLamps(arrayObjectLamps, keySort, title, unit) {
    const arrValues = searchFilters(arrayObjectLamps, keySort);
    (0, addBlockFilter_1.default)(arrValues, title, unit, keySort);
}
//= function searchFilters
// поиск в массиве обьектов со светильниками по значению и формирование и сортировка массива строк
function searchFilters(arrForFilters, key) {
    const arrValue = [];
    arrForFilters.forEach(lamp => {
        if (key && typeof lamp[key] !== 'undefined') {
            const isMatch = arrValue.includes(lamp[key]);
            if (!isMatch) {
                arrValue.push(lamp[key]);
            }
        }
    });
    const sortArr = arrValue.sort((x, y) => {
        return parseInt(x) - parseInt(y);
    });
    return sortArr;
}
exports.default = addFilterLamps;
